import React, { useEffect } from "react";
import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { useDispatch } from "react-redux";
import { logOut } from "../auth/authActions";

// v5 removed per-query onError, so an expired session is detected here by
// watching the caches for failed fetches/mutations. Both caches emit
// { type: "updated", action: { type: "error", error } } once a request has
// exhausted its retries.
const useAuthErrorLogout = client => {
  const dispatch = useDispatch();

  useEffect(() => {
    const handleError = error => {
      if (error?.status === 401 || error?.status === 403) {
        dispatch(logOut());
      }
    };

    const unsubscribeQueries = client.getQueryCache().subscribe(event => {
      if (event.type === "updated" && event.action.type === "error") {
        handleError(event.action.error);
      }
    });
    const unsubscribeMutations = client.getMutationCache().subscribe(event => {
      if (event.type === "updated" && event.action.type === "error") {
        handleError(event.action.error);
      }
    });

    return () => {
      unsubscribeQueries();
      unsubscribeMutations();
    };
  }, [client, dispatch]);
};

export const AppQueryClientProvider = ({ client, children }) => {
  useAuthErrorLogout(client);

  return (
    <QueryClientProvider client={client}>
      <ReactQueryDevtools initialIsOpen={false} />
      {children}
    </QueryClientProvider>
  );
};
